<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2021-04-19 12:06:46
 * @LastEditTime: 2021-04-22 14:42:52
 * @Description: 
-->
<template>
  <div class="drawer-wrapper">
    <CustomerSearchSidebar/>
    <div class="customer-detail-wrap" v-show="selectedCustomer">
      <h1 class="customer-title">{{ selectedCustomer?.name }}</h1>
      <CustomerAnalyzeDetailPanel />
    </div>
    <!-- <Comment class="comment" /> -->
  </div>
</template>

<script>
import { arrayIntersection } from "@/utils";
import { mapActions, mapGetters, mapState } from "vuex";
import CustomerAnalyzeDetailPanel from "./components/CustomerDrawer/CustomerAnalyzeDetailPanel";
import CustomerSearchSidebar from "./components/CustomerDrawer/CustomerSearchSidebar";
import Comment from "@/components/layout/Comment.vue";

export default {
  name: "CustomerDetail",
  components: {
    CustomerAnalyzeDetailPanel,
    CustomerSearchSidebar,
    Comment,
  },
  data() {
    return {
      tableHeight: 300,
    };
  },
  computed: {
    ...mapGetters({}),
    ...mapState({
      user: (state) => state.auth.currentUser,
      userList: (state) => state.user.userList,
      departmentList: (state) => state.department.departmentList,
      selectedCustomer: (state) => state.customerAnalyze.selectedCustomer,
    }),
  },
  methods: {
    ...mapActions({
      getUsersList: "user/getSimpleUserListAction",
      selectCustomer: "customerAnalyze/selectCustomerAction",
    }),
  },
  async created() {
  },
  async mounted() {
    // this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // window.onresize = () => {
    //   this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // };
    if (this.$route.query.id) {
      await this.selectCustomer({_id: this.$route.query.id});
    }
    await this.getUsersList({ simpleRole: 'sales' })
  },
  // destroyed() {
  //   window.onresize = null;
  // },
};
</script>

<style scoped lang="stylus">
.drawer-wrapper
  display flex
  justify-content space-between
  padding 0

.customer-detail-wrap
  flex 1
  height 100%
.customer-detail
  height 100%
  padding-bottom 32px

.customer-title
  margin 20px 0
  display inline-block
  padding 0 16px

.comment
  width 320px
</style>
